import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { spriteData } from "../../dist/svg-sprite/feature-icons-data.js";
import styles from "../stylesheets/components/accommodation-feature-icon.module.css";
import SvgUseIcon from "./SvgUseIcon.js";

const { spriteFileName, viewBoxes, symbolIdPrefix } = spriteData;

interface Props {
  className?: string;
  featureId: number;
}

const AccommodationFeatureIcon: FunctionComponent<Props> = ({
  featureId,
  className,
}) => {
  const glyph = ("feature-" + featureId) as keyof typeof viewBoxes;
  const viewBox = viewBoxes[glyph];

  if (!viewBox) return null;

  return (
    <SvgUseIcon
      className={ClassNames(styles.AccommodationFeatureIcon, className)}
      viewBox={viewBox}
      glyph={glyph}
      symbolIdPrefix={symbolIdPrefix}
      spriteFileName={spriteFileName}
      svgClassName={styles.AccommodationFeatureIcon_Inner}
    />
  );
};

export default AccommodationFeatureIcon;
